export default {
  width: 24,
  height: 28,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.52285 0.188037C1.99978 -0.0763014 2.5826 -0.0609988 3.045 0.228003L23.045 12.728C23.4836 13.0021 23.75 13.4828 23.75 14C23.75 14.5172 23.4836 14.9979 23.045 15.272L3.045 27.772C2.5826 28.061 1.99978 28.0763 1.52285 27.812C1.04592 27.5476 0.75 27.0453 0.75 26.5V1.5C0.75 0.954713 1.04592 0.452375 1.52285 0.188037ZM3.75 4.20637V23.7936L19.4198 14L3.75 4.20637Z"/>
`,
}
